import { Component, OnInit, Input,Output,EventEmitter } from '@angular/core';

//  inspirado em:  https://github.com/nexmo-community/nexmo-stitch-angular

@Component({
  selector: 'messages-control',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {
  text:string="";
  FItem = {};
  @Input()
  to:string='';
  @Input()
  get events() {
    return this.FItem;
  }
  set events(x){
    this.FItem = x;
  }
  @Input()
  me:string = "";

  @Output()
  send = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  carimbaHora(dh:Date){
    return dh.toDateString() ;
    
  }
  sendText(){
    this.send.emit(this.text);
    this.text = "";
  }
}
